import type { IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { Option } from 'src/types';

export enum PrebidVersionFilterValues {
  PREBID_9 = '9',
  PREBID_10 = '10',
}

export enum TagsListSearchKey {
  SEARCH_QUERY = 'searchQuery',
}

export type TagsListFiltersState = {
  searchQuery: string;
  includeInactive: boolean;
  prebidVersion: Option<PrebidVersionFilterValues> | null;
};

export interface TagsListRouteParams {
  integrationType: IntegrationType;
}
